import {
    postApiAdminOperationsHealthOpen,
    postApiAdminOperationsHealthClose,
    postApiAdminOperationsHealthEnable,
    postApiAdminOperationsHealthPolicy,
    getApiOperationsDegradation,
    getApiOperationsMine,
} from '../../../generated/apiClient';
import apiClient from '../../../api/client';
import { API_ENDPOINTS } from '../../../constants/apiEndpoints';

/**
 * Operations admin API wrappers.
 * NOTE: generated endpoints with a request body do not expose a `data`
 * parameter, so bodies are passed through the axios `options` spread.
 */

/** Provider health snapshot - shared staff (Admin + Operator) */
export const getProviderHealth = async () => {
    // Prefer staff endpoint for shared access
    const res = await apiClient.get(API_ENDPOINTS.STAFF_OPERATIONS.HEALTH);
    return res?.data ?? res;
};

/** Operations dashboard aggregate - shared staff */
export const getOperationsDashboard = async () => {
    const res = await apiClient.get(API_ENDPOINTS.STAFF_OPERATIONS.DASHBOARD);
    return res?.data ?? res;
};

/** Queue list with filters - shared staff */
export const getOperationsQueue = async (params = {}) => {
    const res = await apiClient.get(API_ENDPOINTS.STAFF_OPERATIONS.QUEUE, {}, { params });
    return res?.data ?? res;
};

export const getOperationDetail = async (id) => {
    const res = await apiClient.get(API_ENDPOINTS.STAFF_OPERATIONS.QUEUE_DETAIL, { id });
    return res?.data ?? res;
};

export const retryOperation = async (id) => {
    const res = await apiClient.post(API_ENDPOINTS.STAFF_OPERATIONS.QUEUE_RETRY, {}, { id });
    return res?.data ?? res;
};

export const cancelOperation = async (id) => {
    const res = await apiClient.post(API_ENDPOINTS.STAFF_OPERATIONS.QUEUE_CANCEL, {}, { id });
    return res?.data ?? res;
};

/** DLQ list - shared staff */
export const getDlqEntries = async (params = {}) => {
    const res = await apiClient.get(API_ENDPOINTS.STAFF_OPERATIONS.DLQ, {}, { params });
    return res?.data ?? res;
};

export const getDlqEntry = async (id) => {
    const res = await apiClient.get(API_ENDPOINTS.STAFF_OPERATIONS.DLQ_DETAIL, { id });
    return res?.data ?? res;
};

export const retryDlqEntry = async (id) => {
    const res = await apiClient.post(API_ENDPOINTS.STAFF_OPERATIONS.DLQ_RETRY, {}, { id });
    return res?.data ?? res;
};

export const resolveDlqEntry = async (id, body = {}) => {
    const res = await apiClient.post(API_ENDPOINTS.STAFF_OPERATIONS.DLQ_RESOLVE, body, { id });
    return res?.data ?? res;
};

/** Compensation jobs - shared staff */
export const getCompensationJobs = async (params = {}) => {
    const res = await apiClient.get(API_ENDPOINTS.STAFF_OPERATIONS.COMPENSATION, {}, { params });
    return res?.data ?? res;
};

export const getCompensationJob = async (id) => {
    const res = await apiClient.get(API_ENDPOINTS.STAFF_OPERATIONS.COMPENSATION_DETAIL, { id });
    return res?.data ?? res;
};

// Legacy: keep admin fallbacks for backward compatibility (Admin only)
export const getAdminOperationsDashboard = getOperationsDashboard;
export const getAdminOperationsQueue = getOperationsQueue;

/** Circuit-breaker controls (admin only) */
export const openProviderCircuit = async (provider) => {
    const res = await postApiAdminOperationsHealthOpen(provider);
    return res?.data ?? res;
};

export const closeProviderCircuit = async (provider) => {
    const res = await postApiAdminOperationsHealthClose(provider);
    return res?.data ?? res;
};

export const setProviderEnabled = async (provider, enabled) => {
    const res = await postApiAdminOperationsHealthEnable(provider, { enabled });
    return res?.data ?? res;
};

export const setProviderPolicy = async (provider, policy) => {
    const res = await postApiAdminOperationsHealthPolicy(provider, policy);
    return res?.data ?? res;
};

/** User degradation status */
export const getDegradationStatus = async () => {
    const res = await getApiOperationsDegradation();
    return res?.data ?? res;
};

/** User's own tracked operations */
export const getMyOperations = async () => {
    const res = await getApiOperationsMine();
    return res?.data ?? res;
};